import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Button from '../../Button';

interface IProps {
  stationIndex: number;
  stations: any;
  keyword: string;
  setKeyword: (keyword: string) => void;
  address: string|undefined;
}

const SearchBar = styled.div`
  width: 100%;
`;

const MapContainer = styled.div`
  width: 600px;
  height: 450px;
`;

const EditLocation: FC<IProps> = ({
  stationIndex, stations, keyword, setKeyword, address
}) => {
  const { t } = useTranslation();
  const { kakao } = window;
  const [searchTrigger, setSearchTrigger] = useState(false);
  let map2: any = null;

  useEffect(() => {
    setMap();
  }, [searchTrigger, stationIndex]);

  const setMap = () => {
    const container = document.querySelector('#map2');
    const options = {
      center: new kakao.maps.LatLng('37.56642510458935', '126.97794052669803'),
      level: 5
    };
    map2 = new kakao.maps.Map(container, options);
    // 확대/축소 컨트롤
    const zoomControl = new kakao.maps.ZoomControl();
    map2.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

    const lat = stations[stationIndex]?.latitude;
    const lng = stations[stationIndex]?.longitude;
    if (lat && lng) {
      renderMarker(lat, lng);
    } else {
      // 캠퍼스 주소로 맵 지정
      const geocoder = new kakao.maps.services.Geocoder();
      geocoder.addressSearch(address || '', (result: any, status: any) => {
        if (status === kakao.maps.services.Status.OK) {
          const position = new kakao.maps.LatLng(result[0].y, result[0].x);
          map2.setCenter(position);
        }
      });
    }

    // 지도 클릭
    kakao.maps.event.addListener(map2, 'click', (mouseEvent: any) => {
      const lat = mouseEvent.latLng.getLat();
      const lng = mouseEvent.latLng.getLng();
      renderMarker(lat, lng);
    });

    // 지도 검색
    if (!keyword) return;
    const places = new kakao.maps.services.Places();
    places.keywordSearch(keyword, (data: any, status: any) => {
      if (status === kakao.maps.services.Status.OK) {
        const bounds = new kakao.maps.LatLngBounds();
        data.forEach((item: any) => bounds.extend(new kakao.maps.LatLng(item.y, item.x)));
        map2.setBounds(bounds);
      }
    });
  }

  let prevMarker: any;
  const renderMarker = (lat: string, lng: string) => {
    const position = new kakao.maps.LatLng(lat, lng);
    const marker = new kakao.maps.Marker({ position });
    marker.setMap(map2);

    if (prevMarker) prevMarker.setMap(null);
    prevMarker = marker;
    sessionStorage.setItem('lat', lat);
    sessionStorage.setItem('lng', lng);
    map2.setCenter(position);
  }

  const onSearch = () => {
    if (!keyword) return;
    setSearchTrigger(!searchTrigger);
  }

  return (
    <>
      <div>
        <SearchBar className="comm-bx__between comm-gap">
          <div className="flex-fill">
            <input
              type="text"
              className="form-control input-text"
              value={keyword}
              onChange={e => setKeyword(e.target.value)}
              onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
            />
          </div>
          <div className="btn-ba">
              <Button
                className="btn-basic black small"
                onClick={onSearch}
                text={t('common.button.search')}
              />
          </div>
        </SearchBar>
      </div>

      <MapContainer id="map2" />
    </>
  )
}

export default EditLocation;
